import { createFileRoute } from "@tanstack/react-router";
import { LiderRaportPage } from "@/features/contracts/lider-raport-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/raporty/lider")({
	component: LiderRaportPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.raporty-lider",
			location.pathname,
		);
	},
});
